import React from 'react';

import AreaImageForm from './areaimageform/AreaImageForm';
import AreaInfoForm from './areainfoform/AreaInfoForm';
import AreaFileForm from './areafileform/AreaFileForm';
import AreaGeoForm from './areageoform/AreaGeoForm';
import WizardForm from '../wizardform/WizardForm';

export const AddAreaForm = props => {
  return (
    <WizardForm
      onSubmit={props.onSubmit}
      steps={[AreaInfoForm, AreaFileForm, AreaGeoForm, AreaImageForm]}
      props={{
        sites: props.sites
      }}
    />
  );
};

export default AddAreaForm;



// WEBPACK FOOTER //
// ./src/components/forms/addareaform/AddAreaForm.js